export default __webpack_public_path__ + "fonts/66465982ff11fc318ed5826367c6f3d1.woff";